<template>
  <div class="tips">
    <span>{{ isHistory ? $t('invoice.redProcessTips.history') : $t('invoice.redProcessTips.current') }}</span><br>
    <ul class="tips-list">
      <li>{{ $t('invoice.redProcessTips.step1') }}</li>
      <li>
        {{ $t('invoice.redProcessTips.step2') }}
        <ul class="tips-list-sub">
          <li>{{ $t('invoice.redProcessTips.step21', { url: etaxUrl }) }}</li>
          <li>{{ $t('invoice.redProcessTips.step22') }}</li>
          <li>{{ $t('invoice.redProcessTips.step23') }}</li>
        </ul>
      </li>
    </ul>

    <p class="tips-link">
      {{ $t('invoice.redProcessTips.guideText') }}<a
        href="https://www.yuque.com/help.xiaoman/irikgd/iu8aoawk0me7kvre"
        target="_blank"
      >{{ $t('invoice.redProcessTips.guideLink') }}</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'InvoiceTips',
  props: {
    etaxUrl: {
      type: String,
      default: ''
    },
    isHistory: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style lang="scss" scoped>
.tips {
  padding: 12px 16px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin-bottom: 16px;
  line-height: 1.6;
  color: #666;
  font-size: 14px;
}
.tips-list {
  list-style: disc;
  padding-left: 20px;

  li {
    list-style: disc;
  }
}
.tips-list-sub {
  list-style: circle;
  padding-left: 20px;

  li {
    list-style: circle;
  }
}
.tips-link {
  margin-top: 8px;

  a {
    cursor: pointer;
    font-weight: 600;
  }
}
</style>